import MapDisplay from './MapDisplay';

export default MapDisplay;
